exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-sm { margin-top: 10px; }\r\n.transaction-charges { margin: auto; }\r\n.link-tnc { text-decoration: underline; cursor: pointer;color: steelblue; display: inline-block; }\r\n\r\n.captcha-container {  \r\n    margin-bottom: 10px;  \r\n   }  \r\n  .error-message {  \r\n    color: red;  \r\n   }  ", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/quickPay/quickPay.component.css
// module id = ../../../../../src/app/components/quickPay/quickPay.component.css
// module chunks = 0